module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-learn.c716c712.webp";